import type { ListBuilderList } from '../../../types';
import {
	createClientInfoColumn,
	createClientRoutesColumn,
	createDatesColumn,
	createOrderErpNumbersColumn,
	createOrderLinesColumn,
	createOrderTotalsColumn,
	createRoutingColumn,
	createStatusOriginColumn,
} from '../columns';
import {
	ORDER_MOBILE_CARD_CONFIG,
	ORDER_REQUIRED_FIELDS,
	SALES_REP_FILTER_RULES,
} from '../shared';

/**
 * Routing list configuration (PD-15465)
 *
 * Bundled for every tenant but INACTIVE by default: the ListView tab strip
 * renders only `active: true` lists while the full set feeds the Configure
 * List picker, so the tab is available everywhere and joins a user's strip
 * only when they enable it. No capability/setting gate — tenants that don't
 * use routing simply never enable it.
 *
 * Defaults to Approved orders. Opens with the standard order identity
 * columns (status, order numbers, client — matching the other order lists,
 * PD-15556), then the two routing facts: the order's trip state
 * ("On Trip #N" linked / "Not routed") and the client's active
 * route-blueprint membership. Both are flattened onto list rows by
 * OrdersService when `tripId` / `clientRoutes` are among the requested
 * fields (see `_attachRoutingInfo`).
 */
export const routingList: ListBuilderList = {
	id: 'routing',
	cacheTTL: 600000,
	name: 'Routing',
	type: 'default',
	active: false,
	sortOrder: 7,
	columns: [
		createStatusOriginColumn(),
		createOrderErpNumbersColumn(),
		createClientInfoColumn(),
		createRoutingColumn(),
		createClientRoutesColumn(),
		createDatesColumn(),
		createOrderLinesColumn(),
		createOrderTotalsColumn(),
	],
	mobileCardConfig: ORDER_MOBILE_CARD_CONFIG,
	description:
		'Approved orders with their routing state — on a trip or awaiting dispatch',
	defaultSortId: 'column-dates-asc',
	requiredFields: [...ORDER_REQUIRED_FIELDS, 'tripId', 'clientRoutes'],
	filterRules: {
		...SALES_REP_FILTER_RULES,
		orderStatus: {
			defaultValue: [
				{
					id: '4',
					data: {
						id: '4',
						label: 'Approved',
					},
					label: 'Approved',
				},
			],
		},
	},
};
